module.exports = __webpack_public_path__ + "img/email.73ac83a1.svg";